module.exports = __webpack_public_path__ + "static/media/update_prd_response.4538c6ce.png";